export default "__VITE_ASSET__EpbC6$$X__"